/**
 * Speaking content validator
 * Validates speaking data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { SpeakingData } from './schema';

export const speakingValidator: ContentValidator<SpeakingData> = {
    validate(data: SpeakingData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        const items = data?.items ?? [];
        if (items.length === 0) {
            errors.push({ field: 'items', message: 'At least one speaking prompt is required.' });
        }

        return { isValid: errors.length === 0, errors };
    },
};
